import { Link, useLocation, useHistory } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useState, useEffect, useContext } from "react";
import { loginFetcher } from "../../api/requests";
import { AuthContext } from "../../context/auth";
import Cookies from "js-cookie";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { useToaster } from "../../context/toaster";

function Login() {
  const [userData, setUserData] = useState({
    username: "",
    password: "",
  });
  const [verification, setVerification] = useState({
    username: "",
    usernameStatus: false,
    password: "",
    passwordStatus: false,
  });
  const [errors, setErrors] = useState({
    status: false,
    messages: [],
  });
  const { updateUser, user } = useContext(AuthContext);
  const history = useHistory();
  const location = useLocation();
  const [passType, setPassType] = useState("password");
  const [loading, setLoading] = useState(false);
  const { addMessage } = useToaster();
  const logo2 = process.env.PUBLIC_URL + "/img/vaghfnama-logo.png";

  const showToast = (type, text) => {
    addMessage({
      id: Math.random().toString(36).substr(2, 9),
      type: type,
      text: text,
    });
  };

  const handleUsernameChange = (e) => {
    setUserData({ ...userData, username: e.target.value.trim() });
  };

  const handlePasswordChange = (e) => {
    setUserData({ ...userData, password: e.target.value.trim() });
  };

  const handleLoginClick = async () => {
    try {
      setLoading(true);
      if (
        (/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#$%^&*]{8,}$/.test(
          userData.password
        ) &&
          (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userData.username) ||
            /^09\d{9}$/.test(userData.username))) ||
        /^ogh\./i.test(userData.username)
      ) {
        const loginResponse = await loginFetcher.post(userData);
        updateUser(loginResponse);
        setLoading(false);
        if (loginResponse.message === "Login successful") {
          setErrors({ ...errors, messages: [""] });
          const { from } = location.state || {
            from: {
              pathname:
                loginResponse.role === "is_superuser" ||
                loginResponse.role === "is_supervisor"
                  ? "/statistics"
                  : "/",
            },
          };
          history.push(from);
          showToast("success", "با موفقیت وارد شدید.");
        }
      } else {
        setLoading(false);
        setErrors({ ...errors, messages: ["اطلاعات ورود صحیح نمی باشد."] });
        setErrors((prevErrors) => ({
          ...prevErrors,
          status: true,
        }));
      }
    } catch (error) {
      setLoading(false);
      console.error("Login failed", Object.values(error.response.data));
      setErrors((prevErrors) => ({
        ...prevErrors,
        status: true,
        messages: Object.values(error.response.data),
      }));
    }
  };

  const handleEyeClick = () => {
    passType === "password" ? setPassType("text") : setPassType("password");
  };

  useEffect(() => {
    const user = Cookies.get("vaghfnamaUser");
    if (user) {
      const parsedUser = JSON.parse(user);
      if (parsedUser?.username) {
        setUserData((prevValues) => ({
          ...prevValues,
          username: parsedUser.username,
        }));
      }
    } else {
      setUserData((prevValues) => ({
        ...prevValues,
        username: "",
      }));
    }
  }, []);

  return (
    <>
      <Col md={5} className=" p-5 bg-white full-height">
        <div className="login-main-left">
          <div className="text-center mb-5 login-main-left-header pt-4">
            <a href="/">
              <img src={logo2} width="40%" className="img-fluid" alt="LOGO" />
            </a>
            <h5 className="mt-3 mb-3">خوش آمدید</h5>
            <p>لطفا وارد شوید.</p>
          </div>
          <Form className="text-right">
            <Form.Group>
              <Form.Label>نام کاربری (ایمیل یا شماره موبایل)</Form.Label>
              <Form.Control
                value={userData.username ? userData.username : ""}
                type="text"
                placeholder="نام کاربری خود را وارد کنید..."
                onChange={handleUsernameChange}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleLoginClick();
                }}
              />
              {verification.usernameStatus && (
                <p className="text-danger">{verification.email}</p>
              )}
              {verification.usernameStatus && (
                <p className="text-danger">{verification.number}</p>
              )}
            </Form.Group>

            <Form.Group>
              <Form.Label>رمزعبور</Form.Label>
              <div style={{ position: "relative", width: "100%" }}>
                <Form.Control
                  type={passType}
                  placeholder="رمزعبور"
                  onChange={handlePasswordChange}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") handleLoginClick();
                  }}
                />
                <FontAwesomeIcon
                  width={12}
                  height={12}
                  icon={faEye}
                  style={{
                    position: "absolute",
                    top: "30%",
                    left: "3%",
                    cursor: "pointer",
                  }}
                  color="#deb887"
                  onClick={handleEyeClick}
                />
              </div>
              {verification.passwordStatus && (
                <p className="text-danger">{verification.password}</p>
              )}
            </Form.Group>

            <div className="mt-4">
              <Row>
                <Col>
                  <Button
                    style={{ cursor: loading ? "wait" : "pointer" }}
                    onClick={handleLoginClick}
                    variant="outline-primary"
                    size="lg"
                    block
                  >
                    {loading ? "لطفا منتظر بمانید..." : "ورود"}
                  </Button>
                  {errors.status &&
                    errors.messages.map((item, index) => (
                      <p key={index} className="text-danger mt-1">
                        {item}
                      </p>
                    ))}
                </Col>
              </Row>
            </div>
          </Form>

          <div className="text-center mt-4">
            <p className="light-gray">
              در کانال{" "}
              <a
                href="https://eitaa.com/joinchat/2880832496C155a6954d3"
                className="text-primary-custom"
                target="_blank"
              >
                پشتیبانی
              </a>{" "}
              وقف نما در ایتا عضو شوید.
            </p>
            <p className="light-gray">
              حساب کاربری ندارید؟ <a href="/auth/register">ثبت نام</a>
            </p>
            <p className="light-gray">
              <Link to="/auth/forget-password">فراموشی رمزعبور</Link>
            </p>
          </div>
        </div>
      </Col>
    </>
  );
}

export default Login;
